import { useState } from 'react'
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { styled } from '@mui/material/styles'
import { NavLink } from 'react-router-dom'
import menuItems from './items'
import { Box } from '@mui/system'
import { ExpandLess, ExpandMore } from '@mui/icons-material'

const LinkContainer = styled(Box)(
  ({theme}) => `
    .MuiListItemButton-root{
      .MuiTypography-root{
        font-weight: bold;
      }
      &.active, :hover{
        background-color: ${theme.sidebar.menuItemBgActive};
        color: ${theme.sidebar.menuItemColorActive};
        .MuiListItemIcon-root{
          .MuiSvgIcon-root{
            color: ${theme.sidebar.menuItemIconColorActive};
          }
        }
      }
    }
    .MuiListItemIcon-root{
      min-width: 40px;
      .MuiSvgIcon-root{
        font-size: ${theme.typography.pxToRem(26)};
        margin-right: ${theme.spacing(.5)};
        color: ${theme.sidebar.menuItemIconColor};
      }
    }
  `
)

const SidebarItem = ({ name, icon: Icon, iconList, openCollapse, ...rest }): JSX.Element => (
  <LinkContainer>
    <ListItemButton {...rest}>
      <ListItemIcon>
        {Icon && <Icon />}
      </ListItemIcon>
      <ListItemText primary={name} />
      {iconList ? openCollapse ? <ExpandLess /> : <ExpandMore /> : ""}
    </ListItemButton>
  </LinkContainer>
)

const SidebarMenu = (): JSX.Element => {
  const [open, setOpen] = useState({0: true})
  const handleOpen = (i: number) => { setOpen({ ...open, [i]: !open[i] }) }

  return (
    <List component="nav" aria-labelledby="nested-list-subheader">
      {
        menuItems.map((nav, i) => (
          <div key={i}>
            {
              nav.submenu ? (
                <>
                  <SidebarItem
                    name={nav.name}
                    icon={nav.icon}
                    iconList={true}
                    openCollapse={open[i]}
                    onClick={() => handleOpen(i)}
                  />
                  <Collapse in={open[i]} timeout="auto" unmountOnExit >
                    <List component="div" disablePadding>
                      {
                        nav.submenu.map((submenu, j) => (
                          <SidebarItem
                            key={j}
                            name={submenu.name}
                            icon={submenu.icon}
                            sx={{ ml: 2 }}
                            iconList={false}
                            openCollapse={open}
                            component={NavLink}
                            to={submenu.link}
                          />
                        ))
                      }
                    </List>
                  </Collapse>
                </>
              ) : (
                <SidebarItem
                  key={i}
                  name={nav.name}
                  link={nav.link}
                  icon={nav.icon}
                  iconList={false}
                  openCollapse={open}
                  component={NavLink}
                  to={nav.link}
                />
              )
            }
          </div>
        ))
      }
    </List>
  )
}

export default SidebarMenu
